import React from 'react';
import { cn } from '@/lib/utils';

interface BuzzerStageProps {
  className?: string;
  children: React.ReactNode;
}

/**
 * Immersive, viewport-filling backdrop shared by the host and player screens.
 * Mirrors the ChgkTimer fullscreen variant; the z-index sits above the app
 * header (z-3000) so the buzzer really does take over the screen.
 */
const BuzzerStage: React.FC<BuzzerStageProps> = ({ className, children }) => (
  <section
    className={cn('fixed inset-0 z-[3100] flex flex-col overflow-y-auto overscroll-contain text-white', className)}
    style={{ background: 'radial-gradient(ellipse at 50% 38%, #0c1e33 0%, #040b14 100%)' }}
  >
    {/* Subtle grid */}
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0"
      style={{
        backgroundImage:
          'linear-gradient(rgba(56,189,248,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(56,189,248,0.035) 1px, transparent 1px)',
        backgroundSize: '52px 52px',
      }}
    />
    {children}
  </section>
);

export default BuzzerStage;
